import { render, staticRenderFns } from "./collect-point-rank-dialog.vue?vue&type=template&id=4c88fb7e&scoped=true"
import script from "./collect-point-rank-dialog.vue?vue&type=script&lang=js"
export * from "./collect-point-rank-dialog.vue?vue&type=script&lang=js"
import style0 from "./collect-point-rank-dialog.vue?vue&type=style&index=0&id=4c88fb7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c88fb7e",
  null
  
)

export default component.exports